// src/context/GlobalContext.js
import React, { createContext, useState } from 'react';

// Create the context
export const MouseHoverContext = createContext();

// Create a provider component
export const MouseProvider = ({ children }) => {
  const [mousehover, setMouseHover] = useState(false); // Initialize the global variable

  return (
    <MouseHoverContext.Provider value={{mousehover, setMouseHover }}>
      {children}
    </MouseHoverContext.Provider>
  );
};

